module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "block_17"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_19"
  }, [_c('img', {
    staticClass: "calibre5",
    attrs: {
      "alt": "Image",
      "src": "images/image.png"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "block_115",
    attrs: {
      "id": "toc_id_4"
    }
  }, [_vm._v("Chapter 1"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Jacob’s Mysterious Briefcase"), _c('span', {
    staticClass: "tab"
  })]), _vm._v(" "), _c('p', {
    staticClass: "block_17"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_20"
  }, [_c('span', {
    staticClass: "text_"
  }, [_vm._v("Jacob was a short lad, frail too, if you ask me. He had secrets though, big secrets. He would walk around with a large briefcase in his hands. “")]), _c('span', {
    staticClass: "text_"
  }, [_vm._v("He looks like a little businessman")]), _c('span', {
    staticClass: "text_"
  }, [_vm._v("” or “")]), _c('span', {
    staticClass: "text_"
  }, [_vm._v("someone’s had a long day at the office")]), _c('span', {
    staticClass: "text_"
  }, [_vm._v("” were some of the phrase’s adults would say when they encountered Jacob. He acted like one too—an adult that is. He would almost never smile and took all things seriously, especially what was in his briefcase.")])]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("Anyone that paid enough attention could tell that Jacob was of the less fortunate variety. Although clean, his clothing looked a bit wrinkled and worn. The faded patterns and distress around the cuffs of his sleeves gave him away.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“Let’s get you squared away,” a station employee said as he reached for Jacob’s luggage.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“This is a carry-on item, sir!” Jacob snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("The station employee was startled by the boy’s reaction and slowly stepped away from him.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“Forgive me, young man, didn’t mean to give you a fright,” he said attempting to calm Jacob’s nerves. “So, what have you got there?” he probed, inspecting the briefcase from afar. “Candies, cakes, toys maybe?”")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("Jacob stared at him and said not a single word.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“Off with you then. Shirty bugger,” he grumbled. “Get on before you’re left to walk.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("The station employee then took a deep breath. Nostrils flaring, he blew into an obnoxiously loud whistle. Jacob squinted with discontent at the man before sharply turning away.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("Jacob carefully stepped off the boarding platform and onto the train. Once passed the threshold he looked around a bit until he found a spot he liked (a seat far away from everyone else). He slowly walked over to the seat and made himself comfortable, both hands firmly wrapped around his briefcase.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("A small girl, sitting with her uncle, saw everything that had transpired from a cabin window and was instantly curious. The moment Jacob sat down she went to sit next to him and introduce herself.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“Hello!” she said eagerly awaiting a response. Jacob tried his absolute best to ignore her, but she inched closer with every silent moment.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("To pause her progress, he reluctantly spoke.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“Do you always invade private space?” he snapped, turning his face away and towards a window.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“My name’s Abby, and yes… but only when I see something interesting,” chortled the young lady.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“Interesting?” Jacob huffed. “How do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“No offense,” Abby warned, “but a child hugging a briefcase like a teddy, obviously places you in one of two categories.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“Obviously,” Jacob mocked, poking fun at her deduction.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("Abby smiled and declared, “You’re either a dodgy nutter or an exceptional little boy!”")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("Jacob raised an eyebrow while simultaneously lowering the other. “Did you just call me a little boy?” he questioned sharply, further revealing his agitation. “I am clearly a man!”")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“Is that the only part that twisted your knickers?” Abby teased. “Honestly, I don’t see much of a difference.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“Bollocks,” Jacob scoffed. “There’s clearly a difference between a man and a boy.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“Clearly?” Abby said with a devious smile hinting at the man sitting adjacent. “Why then, pray tell, is it so hard to tell you lot apart?”")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("Jacob did not notice that the man sitting across from him was wearing the exact same outfit, moreover, carrying a similar briefcase.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("Jacob investigated the man and instantly realized their similarities. Although a bit embarrassed, he playfully rolled his eyes and began to giggle; Abby joined.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("The man sitting across from them displayed his discontent with furrowed brows and a loud clearing of the throat, prompting the children to conceal their laughter, albeit obvious.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("After looking back and forth at both the man and Jacob, Abby began giggling again, hand over mouth. “What are you on about?” Jacob whispered whilst smiling at the man uncomfortably.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“I mean honestly, it’s like sitting across from yourself at two entirely different points in your life. I’m positive someone has written a book about this,”")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("Abby continued, “Where is Socrates when you need him? I cannot tell if you are dressed like a man, or if he is dressed like a child.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("Jacob’s smile was promptly relinquished.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“Whateva,” he replied, still bearing a grin.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("Abby looked at Jacob for a moment and smiled. “Nutter, brilliant boy, or neither,” she said, “you’re still pretty interesting to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("Jacob smiled. Realizing that this banter could go on forever, he decided to take the proverbial, ‘high road.’")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“If telling you my name will get you to stop insulting people, namely myself, I yield.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_22"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("The introduction that followed would serve as both Jacob’s ‘hello’ and proverbial ‘white flag.’")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“My name is Jacob,” he said hesitantly.")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("“There now, Jacob,” Abby replied whilst giving him a soft punch on the shoulder, “was that so hard?”")]), _vm._v(" "), _c('p', {
    staticClass: "block_21"
  }, [_vm._v("Jacob grinned, “Harder than you think.”")]), _vm._v(" "), _c('p', {
    staticClass: "block_23",
    attrs: {
      "id": "calibre_pb_6"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75f970fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_004.vue
// module id = 75
// module chunks = 0